import React from 'react';
import { GenericAuditLogsCard } from '@/Components/shared/GenericAuditLogsCard';

interface WarrantyAuditLogsCardProps {
  warrantyUuid: string;
}

export const WarrantyAuditLogsCard: React.FC<WarrantyAuditLogsCardProps> = ({ warrantyUuid }) => {
  return (
    <GenericAuditLogsCard
      entityType="warranty"
      entityId={warrantyUuid}
      includeCreationDetails={true}
      shouldGroupCreationLogs={true}
      limit={150}
    />
  );
};
